import { MAPPING_NOT_MAPPED_VALUE } from './mappingConstants';

const CUSTOM_PRODUCT_ATTRIBUTES_KEY = 'customProductAttributes';
const CUSTOM_VARIANT_ATTRIBUTES_KEY = 'customVariantAttributes';

function isMappedTitle(value) {
  return Boolean(value) && value !== MAPPING_NOT_MAPPED_VALUE;
}

export function getMappedTitlesFromDocument(document, scope) {
  const key = scope === 'variant'
    ? CUSTOM_VARIANT_ATTRIBUTES_KEY
    : CUSTOM_PRODUCT_ATTRIBUTES_KEY;

  return new Set(Object.values(document?.[key] || {}).filter(isMappedTitle));
}

export function filterItemsByMappedTitles(items = [], mappedTitles) {
  if (!mappedTitles?.size) return [];

  return items.filter(
    (item) => item.type !== 'separator' && mappedTitles.has(item.title),
  );
}

export function filterMetaDiffByTitles(metaDiff = {}, mappedTitles) {
  if (!mappedTitles?.size) return {};

  return Object.keys(metaDiff).reduce((acc, key) => {
    if (mappedTitles.has(key)) {
      acc[key] = metaDiff[key];
    }
    return acc;
  }, {});
}
